export const state = {
	referrals: [],
	currentReferral: '',
};
